import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';
import {roofFieldName} from "../../../../store/roofData/types";
// import { roofFieldName } from 'src/store/roofData/types';

export const usePresenter = () => {
  const { dispatch, roofStore } = useStoreon<IState, IEvents>('roofStore');

  const changeRoofFieldValue = {
    L_kr: (value: number | null) => {
      dispatch('roof/set-L_kr-value', { value })
    },
    L_k: (value: number | null) => dispatch('roof/set-L_k-value', { value }),
    B_kr: (value: number | null) => dispatch('roof/set-B_kr-value', { value }),
    B_kr1: (value: number | null) => dispatch('roof/set-B_kr1-value', { value }),
    B_kr2: (value: number | null) => dispatch('roof/set-B_kr2-value', { value }),
    H_p1: (value: number | null) => dispatch('roof/set-H_p1-value', { value }),
    H_p2: (value: number | null) => dispatch('roof/set-H_p2-value', { value }),

    L_sk1: (value: number | null) => dispatch('roof/set-L_sk1-value', { value }),
    L_sk2: (value: number | null) => dispatch('roof/set-L_sk2-value', { value }),
  };

  const changeFocusedField = (focusedField: roofFieldName | null) => {
    dispatch('roof/set-focused-field', { focusedField })
  }

  return {
    roofType: roofStore.roofType,
    L_kr: roofStore.L_krValue,
    L_k: roofStore.L_kValue,
    B_kr: roofStore.B_krValue,
    B_kr1: roofStore.B_kr1Value,
    B_kr2: roofStore.B_kr2Value,
    H_p1: roofStore.H_p1Value,
    H_p2: roofStore.H_p2Value,

    L_sk1: roofStore.L_sk1Value,
    L_sk2: roofStore.L_sk2Value,

    changeRoofFieldValue,
    changeFocusedField,
  };
};
